import isURL from 'validator/es/lib/isURL';

const options = { require_protocol: true, protocols: ['http', 'https'] }
const url = (value) => isURL(value, options)

export default url
